// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__nnR13","packageList":"styles_packageList__tSd9I","loadingWrapper":"styles_loadingWrapper__9IVGf","changeSize":"styles_changeSize__fbb7P"};